<template>
    <b-form ref="form" :save-url="addUrl" @success="formSuccess" v-slot="{model, loading}"
            :initial-data="initialData" :save-params="{course}">
        <div class="row">
            <div class="col-12">
                <validated-vue-select :options="yearOptions" label="Financial Year" v-model="model.financial_year"
                                      :rules="{required: true}" :disabled="loading"/>
            </div>
            <div class="col-12">
                <file-input class="c-file-input" ref="file" label="Image" v-model="model.image_file"
                            :disabled="loading" name="Image File">
                </file-input>
                <image-info :width="835" :height="820"/>
            </div>
            <div class="col-12">
                <validated-text-area label="Description" v-model="model.description"
                                     :rules="{required: true, max: 500}" :disabled="loading"/>
            </div>
            <div class="col-6">
                <validated-input type="number" label="Order" v-model="model.order"
                                 :rules="{required: false, min_value:1}" :disabled="loading"/>
            </div>
            <div class="col-6">
                <validated-checkbox label="Enabled" v-model="model.is_enabled"
                                :rules="{required: false}" :disabled="loading"/>
            </div>
            <div class="col-12">
                <btn class="trn" text="Update" loading-text="Updating..." size="sm" :disabled="loading"
                     :loading="loading"/>
            </div>
        </div>
    </b-form>
</template>

<script>
import urls from '../../../../data/urls';

function generateArrayOfYears () {
    const date = new Date().getFullYear();
    const min = date - 5;
    const years = [];

    for (let i = min; i <= (date + 5); i++) {
        const data = { label: i + '-' + (i + 1), value: i + '-' + (i + 1) };
        years.push(data);
    }
    return years.reverse();
}

export default {
    name: 'EditTrainingSchedule',

    props: {
        initialData: { type: Object },
        course: { type: String }
    },

    data () {
        const Options = generateArrayOfYears();
        return {
            yearOptions: Options,
            year: new Date().getFullYear(),
            addUrl: urls.admin.course.detailsUrl.trainingSchedule.addEdit
        };
    },

    methods: {
        clearFile (file) {
            this.initialData.banner_image = '';
        },
        viewFile (file) {
            window.open(file);
        },
        formSuccess () {
            this.$notify('Successfully Updated Item..!', 'Success',
                {
                    type: 'success'
                }
            );
            this.$emit('success');
        }
    }
};
</script>

<style scoped>

</style>
